module.exports = "../fonts/ProximaNova-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/ProximaNova-Bold.ttf
// module id = 584
// module chunks = 0